import React, { Component } from "react";
import styled from "styled-components";
import TEAM from "team";

const AboutDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px 25%;

  @media (max-width: 750px) {
    padding: 20px;
  }

  @media (max-width: 900px) {
    padding: 10%;
  }

  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

const TeamMember = styled.div`
  margin: 25px 0px;
  .team-photo {
    width: 150px;
    height: 150px;
    background-size: cover;
    border-radius: 75px;
    margin-right: 10px;
  }
  h3 {
    margin-bottom: 0;
  }
  h4 {
    margin-top: 4px;
  }
  @media (max-width: 750px) {
    .team-photo {
      width: 100px;
      height: 100px;
    }
  }
  @media (max-width: 450px) {
    .team-photo {
      width: 80px;
      height: 80px;
    }
  }
`;

class About extends Component {
  renderTeam = (team) =>
    team.map((member, index) => (
      <div>
        <TeamMember key={index} className="flex">
          <div
            className="team-photo"
            style={{ backgroundImage: `url(/assets/team/${member.photo})` }}
          />
          <div style={{ flexShrink: 100 }}>
            <h3 className="body">
              {member.name}, {member.role}
            </h3>
            <h4>{member.quals.join(". ")}</h4>
          </div>
        </TeamMember>
        <p className="body weight-300">{member.blurb}</p>
      </div>
    ));
  render() {
    return (
      <AboutDiv>
        <h1 className="sans-serif">About Us</h1>
        <p className="body m-t-sm">
          *For inquiries, feel free to reach out to us at{" "}
          <a href="mailto:swang@sharonwangarchitect.ca">
            swang@sharonwangarchitect.ca
          </a>{" "}
          or call <a href="tel:4039996842">(403)-999-6842</a>.
        </p>
        <h2 className="body">Services Offered</h2>
        <p className="body">At Sharon Wang Architect, we deal with:</p>
        <ul style={{ fontSize: "1.8rem" }} className="body weight-300">
          <li>Commercial</li>
          <li>Industrial</li>
          <li>Residential</li>
          <li>Cultural (Religious)</li>
        </ul>
        <p className="body">
          We provide various architectural services including:
        </p>
        <ul className="body weight-300">
          <li>Schematic Design</li>
          <li>Development Permits</li>
          <li>Building Permits</li>
          <li>Stamping</li>
        </ul>
        <p className="body">As well as other assorted services:</p>
        <ul className="body weight-300">
          <li>Interior Design</li>
          <li>Landscaping</li>
          <li>Site Planning</li>
          <li>3D Visualization</li>
          <li>Building Code Applications</li>
          <li>Feasibility Studies</li>
          <li>Gap Analysis</li>
          <li>Specification Writing / Review</li>
          <li>Bid Preparation / Evaluation</li>
        </ul>
        <h2 className="body">The Team</h2>
        {this.renderTeam(TEAM)}
      </AboutDiv>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.jsx